const Routes = {
    MAIN: '/main',
    LOGIN: '/login',
    DASHBOARD: '/main/dashboard',
    REDEEM: '/main/redeem'
}

export default Routes;